import { render, staticRenderFns } from "./DashboardsAndReport.vue?vue&type=template&id=4c6bc646&scoped=true&"
import script from "./DashboardsAndReport.vue?vue&type=script&lang=js&"
export * from "./DashboardsAndReport.vue?vue&type=script&lang=js&"
import style0 from "./DashboardsAndReport.vue?vue&type=style&index=0&id=4c6bc646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6bc646",
  null
  
)

export default component.exports